import axiosInstance from "@/common/axiosInstance";
import apiCall from "./apiCall";

interface PaginationParams {
    pageNumber: number;
    pageSize: number;
};

interface GetListSireReviewInvoicesByRequestor extends PaginationParams {
    requestorId: string,
};

interface GetListSireReviewsSimpleForRequestor extends PaginationParams {
    requestorId: string,
    month: number,
    year: number,
};

interface InvoiceSearchParams extends PaginationParams {
    search: string,
    paymentStatus: string,
    invoiceStatus: string,
}

export type SireReviewRequestorInvoice = {
    id: string,
    requestorId: string,
    requestorName: string,
    invoiceNumber?: string,
    invoiceDate: string,
    isMonthly: boolean,
    reviewMonth?: number,
    reviewYear?: number,
    totalReview: number,
    costReview: number,
    kurs: number,
    totalAmount: number,
    totalAmountIDR?: number,
    invoiceStatus: number,
    paymentStatus:number,
    paymentDate?: string,
    paymentFileId?: string,
    invoiceDownloadId: string,
    fakturFileId: string,
    notes?: string,
    ppn: number,
    ppnPrice: number,
    costDownload: number,
};

export type SireReviewRequestorInvoiceDetail = SireReviewRequestorInvoice & {
    invoiceDetails: SireReviewSimpleRequestor[],
};

export type SireReviewSimple = {
    id: string,
    sequenceId: string,
    requestorId: string,
    requestor: string,
    vesselId: string,
    vesselName: string,
    imoNumber: string,
    vesselType: string,
    addAldPertamina: string,
    reviewDate: string,
    created: string,
    createdBy: string,
    isDeleted: boolean,
    modified: string,
    modifiedBy: string,
};

export type SireReviewSimpleRequestor = {
    id: string,
    sireReviewId: string,
    sequenceId: string,
    requestorId: string,
    requestorName: string,
    vesselId: string,
    vesselName: string,
    imoNumber: string,
    vesselType: string,
    addAldPertamina: string,
    reviewDate: string,
    created: string,
    createdBy: string,
    isDeleted: boolean,
    modified: string,
    modifiedBy: string,
    isSecondDownload: boolean,
};

export type SireReviewSimpleRequestorSent = {
    sireReviewId: string,
    sequenceId: string,
    requestorId: string,
    requestorName: string,
    vesselId: string,
    vesselName: string,
    imoNumber: string,
    vesselType: string,
    reviewDate: string,
    addAldPertamina: string,
};

export const getListSireReviewRequestorInvoices = async (param: InvoiceSearchParams) => {
    const query = `?search=${param.search}&paymentStatus=${param.paymentStatus}&invoiceStatus=${param.invoiceStatus}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/RequestorInvoice/GetListRequestorInvoices${query}`;
    return apiCall('get', URL);
};

export const getListSireReviewRequestorInvoicesFinance = async (param: InvoiceSearchParams) => {
    const query = `?search=${param.search}&paymentStatus=${param.paymentStatus}&invoiceStatus=${param.invoiceStatus}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/RequestorInvoice/GetListRequestorInvoicesFinance${query}`;
    return apiCall('get', URL);
};

export const getListSireReviewRequestorInvoicesByRequestor = async (param: GetListSireReviewInvoicesByRequestor) => {
    const query = `?requestorId=${param.requestorId}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/RequestorInvoice/GetListRequestorInvoicesForRequestor${query}`;
    return apiCall('get', URL);
};

export const getSireReviewRequestorInvoiceDetails = async (id: string) => {
    const query = `?Id=${id}`;
    const URL = `/RequestorInvoice/GetRequestorInvoiceById${query}`;
    return apiCall('get', URL);
};

export const getListSireReviewsSimpleByRequestorInvoice = async (invoiceId: string, pageNumber: number, pageSize: number) => {
    const query = `?invoiceId=${invoiceId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    const URL = `/RequestorInvoice/GetListRequestorInvoiceDetailsById${query}`;
    return apiCall('get', URL);
};

export const getListSireReviewsSimpleForRequestor = async (params: GetListSireReviewsSimpleForRequestor) => {
    const query = `?requestorId=${params.requestorId}&month=${params.month}&year=${params.year}&pageNumber=${params.pageNumber}&pageSize=200`;
    const URL = `/RequestorInvoice/GetDataForRequestorInvoiceDetails${query}`;
    return apiCall('get', URL);
};

export const getListSireReviewsSimpleByInvoiceAndRequestor = async (invoiceId: string, requestorId: string, pageNumber: number, pageSize: number) => {
    const query = `?orderNumber=${invoiceId}&requestorId=${requestorId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    const URL = `/RequestorInvoice/GetDataForRequestorByOrderNumberInvoiceDetails${query}`;
    return apiCall('get', URL);
};

export const getListSireReviewsRequestorOrderNumbers = async (requestorId: string) => {
    const query = `?requestorId=${requestorId}`;
    const URL = `/RequestorInvoice/GetListSireReviewOrderNumber${query}`;
    return apiCall('get', URL);
};

export const getSingleSireReviewDetailForRequestor = async (requestorId: string, reviewId: string) => {
    const query = `?requestorId=${requestorId}&sireReviewId=${reviewId}`;
    const URL = `/RequestorInvoice/GetDataForRequestorByOrderNumberInvoiceDetails${query}`;
    return apiCall('get', URL);
};

export const postCreateInvoicesSireReviewRequestor = async (data: object) => {
    const URL = '/RequestorInvoice/Create';
    // return apiCall('post', URL, data);
    try {
        const response = await axiosInstance.post<any>(URL, data, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

export const postUpdateInvoicesSireReviewRequestorFinance = async (data: FormData) => {
    const URL = '/RequestorInvoice/UpdateFakturAndInvoiceNumber';
    // return apiCall('post', URL, data);
    try {
        const response = await axiosInstance.post<any>(URL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

export const postUpdateSireReviewRequestorInvoice = async (data: object) => {
    const URL = '/RequestorInvoice/Update';
    // return apiCall('post', URL, data);
    try {
        const response = await axiosInstance.post<any>(URL, data, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

export const postUpdateSireReviewRequestorInvoicePayment = async (data: FormData) => {
    const URL = '/RequestorInvoice/UpdatePaymentStatus';
    // return apiCall('post', URL, data);
    try {
        const response = await axiosInstance.post<any>(URL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

export const deleteSireReviewRequestorInvoice = async (id: string, userEmail: string) => {
    const URL = '/RequestorInvoice/Delete';
    const data = {
        id,
        modifiedBy: userEmail,
    }
    // return apiCall('post', URL, data);
    try {
        const response = await axiosInstance.post<any>(URL, data, {
            headers: {  
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};
